module.exports = __webpack_public_path__ + "img/c07_buildingstartechtwomansaw_Normal_ua.605fda7a.webp";